<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="x1toc" id="toc_marker-3">contents<a id="x-contents-"></a></p><a id="x-contents-">
<div class="ding">
<img alt="264.png" class="frame-1" src="image/264.png"/>
</div>
</a><p class="TOC-1"><a id="x-contents-"></a><a href="#/SPE#Anchor-8">Introduction</a></p>
<p class="TOC-part"><a href="#/SPE1#Anchor">Part I</a>: foundation<br/><span class="char-style-override-1">Discovering the Gift of Empathy</span></p>
<p class="TOC-2"><a href="#/SPE2#Anchor-9"><span class="sc">Chapter 1</span></a> Your Empathic Gifts: The Clairs</p>
<p class="TOC-2"><a href="#/SPE3#Anchor-10"><span class="sc">Chapter 2</span></a> Your Empathic Body: Wired to Connect</p>
<p class="TOC-2"><a href="#/SPE4#Anchor-11"><span class="sc">Chapter 3</span></a> Compassion: The Lining of the Empath’s Soul</p>
<p class="TOC-2"><a href="#/SPE5#Anchor-12"><span class="sc">Chapter 4</span></a> Learn Your Type: The Six Empathic Styles</p>
<p class="TOC-part"><a href="#/SPE6#Anchor-13">Part II</a>: application<br/><span class="char-style-override-1">Mastering the Gift of Empathy</span></p>
<p class="TOC-2"><a href="#/SPE7#Anchor-14"><span class="sc">Chapter 5</span></a> Tools for Compassionate Empathy</p>
<p class="TOC-2"><a href="#/SPE8#Anchor-15"><span class="sc">Chapter 6</span></a> Empathic Healing: How Empaths<br/>Can Heal Themselves and Others</p>
<p class="TOC-2"><a href="#/SPE9#Anchor-16"><span class="sc">Chapter 7</span></a> The Empath in Relationships</p>
<p class="TOC-2"><a href="#/SPE10#Anchor-17"><span class="sc">Chapter 8</span></a> Empathy and Your Vocation:<br/>The Calling to Care</p>
<p class="TOC-1"><a href="#/SPE11#Anchor-18"><span class="sc char-style-override-2">Conclusion</span></a> Embrace Your Gifts: The Joy of Empathy</p>
<p class="TOC-1"><a href="#/SPE12#Anchor-19"><span class="sc char-style-override-2">Appendix 1</span></a> Sympathy (and Other Empathy Impostors)</p>
<p class="TOC-1"><a href="#/SPE13#Anchor-20"><span class="sc char-style-override-2">Appendix 2</span></a> Impaired Empaths</p>
<p class="TOC-1"><a href="#/SPE14#Anchor-21">Glossary</a></p>
<p class="TOC-1"><a href="#/SPE15#Anchor-22">Resource Recommendations</a></p>
<p class="TOC-1"><a href="#/SPE16#Anchor-23">Notes</a></p>
<p class="TOC-part">Empathic Explorations</p>
<p class="TOC-1"><a href="#/SPE2#Look-to-Your-Own-Experience">Look to Your Own Experience</a></p>
<p class="TOC-1"><a href="#/SPE3#What-Do-You-Feel-in-Your-Body">What Do You Feel in Your Body</a> </p>
<p class="TOC-1"><a href="#/SPE4#What-Isn-t-Empathy">What Isn’t Empathy</a>? </p>
<p class="TOC-1"><a href="#/SPE5#What-is-Your-Style">What is Your Style</a>? </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?7e9cd3dd